<div class="flex-1 overflow-y-auto">
  <app-page-header [title]="'objectives.title' | transloco" />

  <p-tabs
    [value]="activeTab()"
    (valueChange)="setTab($any($event))"
    [dt]="{
      tablistBackground: 'transparent',
      tabBorderWidth: '0 0 2px 0',
      tabBackground: 'transparent',
      tabActiveBackground: 'transparent',
    }"
  >
    <p-tablist>
      @for (tab of tabs(); track tab.id) {
        <p-tab [value]="tab.id" class="flex items-center !gap-2 text-inherit">
          <span class="relative flex shrink-0 items-center justify-center">
            <lucide-icon [name]="tab.iconName" [size]="18" />
            @if (tab.warning) {
              <span
                class="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-orange-500"
                role="img"
                [attr.aria-label]="'objectives.notDefinedYet' | transloco"
              ></span>
            }
          </span>
          <span>{{ tab.labelKey | transloco }}</span>
        </p-tab>
      }
    </p-tablist>
  </p-tabs>

  <div class="mt-6 max-w-7xl">
    @switch (activeTab()) {
      @case ("target") {
        <app-reduction-target />
      }
      @case ("actions") {
        <app-climate-actions />
      }
      @case ("risks") {
        <app-climate-risks />
      }
    }
  </div>
</div>
